import * as types from '../mutation-types'
import { getCookie } from '../../utils/cookies'

// initial state
const state = {
  token: getCookie('token') || null
}

// mutations
const mutations = {
  [types.LOGIN_SUCCESS] (state, action) {
    state.token = action.token
  },

  [types.USERINFO_SUCCESS] (state, { action }) {
    state.user = action.user
  },

  [types.USERINFO_FAILURE] (state, { action }) {
    state.user = null
  },

  [types.LOGOUT_USER] (state, { action }) {
    state.token = getCookie('token') || null
    state.token = null
  },

  [types.UPDATE_USER_SUCCESS] (state, { action }) {
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js